import http from './http';

export default {
  search(data) {
    return http().post(`/v1/zillow/search`, data);
  },
}
